import { List, Map } from "immutable";
import { MappedStore } from "@core/store/mappedStore";
import { ComplexMappedStorePresentation } from "@core/store/mappedStorePresentation";
import { SimpleStore } from "@core/store/store";
import { WalletDto } from "./dto";
import { AllWallet, Cashable, Disbursement, Earning, TransactionFilterOptions, Wallet } from "./wallet";
import { WalletApi } from "./walletApi";
import { DisbursementDraft, WalletDraft } from "./walletDraft";

export class WalletService {
	transactionStore: SimpleStore<WalletDto>;
	alltransactionsStore: MappedStore<WalletDto, { filterOption?: TransactionFilterOptions; groupId: string }>;

	// alldisbursementsStore = new MappedStorePresentation(
	// 	this.transactionStore,
	// 		// 	(groupId: string, page) => {
	// 		// console.log("groupID", this.walletApi.listDisbursements(groupId, page));
	// 		return this.walletApi.listDisbursements(groupId, page);
	// 	}
	// );

	constructor(
		private readonly walletApi: WalletApi,
		initialWallet?: Map<string, Wallet>
	) {
		this.transactionStore = new SimpleStore((id) => this.walletApi.getTransactionById(id));
		if (initialWallet) {
			this.transactionStore.merge(List(initialWallet.values()));
		}

		this.alltransactionsStore = new ComplexMappedStorePresentation(
			this.transactionStore,
			({ filterOption, groupId }, page) => {
				return this.walletApi.listTransactions(filterOption, page, groupId);
			}
		);
	}

	async save(draft: WalletDraft, groupId: string): Promise<Wallet> {
		const wallet = await this.walletApi.create(draft, groupId);
		return wallet;
	}

	async getWallet(): Promise<Array<AllWallet>> {
		return this.walletApi.getWallet();
	}

	async getEarning(groupId: string): Promise<Earning> {
		return this.walletApi.getEarning(groupId);
	}

	async getCashable(groupId: string): Promise<Cashable> {
		return this.walletApi.getCashable(groupId);
	}
	async listDisbursements(groupID: string): Promise<Array<Disbursement>> {
		return this.walletApi.listDisbursements(groupID);
	}
	async cashout(draft: DisbursementDraft, groupId: string): Promise<Disbursement> {
		const wallet = await this.walletApi.cashout(draft, groupId);
		return wallet;
	}
}
